const createErrorMessageSelector = (actions) => (state) => {
  const errors = actions.map((action) => state.errorReducer[action]).filter((err) => !!err);
  if (errors && errors[0]) {
    return errors[0];
  }
  return '';
};

export default createErrorMessageSelector;
